<template>
  <div class='m-t-60'>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data' >
      <template v-slot:action="{ record }">
        <a-button type="link" @click="set(record.id)" >
          设置
        </a-button>
      </template>
    </a-table>
  <!--<a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" /> -->
  </div>
</template>
<script>
import { inject, reactive, ref ,toRefs} from "vue";
import { getmessage,createReceiver,delReceiver,receiverDetail,editReceiver } from "@/api/message.js";
import { iscode } from "@/utils/app";
import { message } from 'ant-design-vue';
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
};
export default {
  setup() {
    let columns = [
  
      {
        title: "模版ID",
        dataIndex: "app_name",
        key: "app_name",
      },
      {
        title: "操作人",
        dataIndex: "project",
        key: "project",
      },
       {
        title: "操作类型",
        dataIndex: "create_time",
          customRender:({record})=>{
          return  record.email?'开启':'关闭' 
        }
      },
       {
        title: "操作时间",
        dataIndex: "create_time",
         customRender:({record})=>{
          return  record.sms?'开启':'关闭' 
        }
      }
    ];
   const state= reactive({
      receiverVisible:false,
      confirmLoading:false,
    })
    const  $Modal=inject('$Modal')
    //初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    let listLoading = ref(false);
    let data = ref([]);
    const initData = async (values) => {
      listLoading.value = true;
      let res = await getmessage(values).then((res) => res);
      listLoading.value = false;
      data.value = res.data.data;
    };
    initData(search.value)
    return {
      columns,
      listLoading,
      data,
      ...toRefs(state),
    };
  },
};
</script>